/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type FlatDispositionEnum = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;

export const FlatDispositionEnum = {
    NUMBER_1: 1 as FlatDispositionEnum,
    NUMBER_2: 2 as FlatDispositionEnum,
    NUMBER_3: 3 as FlatDispositionEnum,
    NUMBER_4: 4 as FlatDispositionEnum,
    NUMBER_5: 5 as FlatDispositionEnum,
    NUMBER_6: 6 as FlatDispositionEnum,
    NUMBER_7: 7 as FlatDispositionEnum,
    NUMBER_8: 8 as FlatDispositionEnum,
    NUMBER_9: 9 as FlatDispositionEnum,
    NUMBER_10: 10 as FlatDispositionEnum,
    NUMBER_11: 11 as FlatDispositionEnum
};

